import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';

export default function PageLayout({ children }) {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768
  );

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={styles.layout}>
      <Sidebar />
      <div style={{
        ...styles.main,
        paddingTop: isMobile ? '72px' : '26px',
      }}>
        {children}
      </div>
    </div>
  );
}

const styles = {
  layout: {
    display: 'flex',
    minHeight: '100vh',
    background: '#F6F4EE',
  },
  main: {
    flex: 1,
    padding: '26px',
    overflowY: 'auto',
    maxWidth: '100%',
    width: '100%',
  },
};